import config from '../../config'
import { HTTP } from  '../../http'

export default {
    getAll: () => {
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.eventsUri).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
}